import { Grid, IconButton } from '@material-ui/core';
import { ChevronRightOutlined } from '@material-ui/icons';
import PhoneInTalkOutlinedIcon from '@material-ui/icons/PhoneInTalkOutlined';
import { CASABLANCA } from 'components/MapFilter/constants';
import {
  StyledCallIcon,
  StyledItemActionText,
  StyledItemTitle,
  StyledLink,
  StyledItemWrapper,
} from 'containers/ContactsUtilsPage/styles';
import { ItemProps } from 'containers/ContactsUtilsPage/types';
import { pushTo } from 'helpers/routes';
import { AssuranceIcon } from 'images';
import get from 'lodash/get';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getLocations } from 'store/global/actions';
import PAGES from 'routes/pages';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
const Item = ({
  param,
  title,
  type,
  icon,
  action,
  phoneText,
}: ItemProps & { phoneText: string }) => {
  const dispatch = useDispatch();

  return (
    <GaClickHOC category={EVENT_CATEGORIES.CONTACTS} label={title}>
      <StyledItemWrapper marginY={2} icon={icon}>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Grid container justify="center" alignItems="center">
              <img alt={title} src={get(AssuranceIcon, icon)}></img>
              <StyledItemTitle type={type}>{title}</StyledItemTitle>
            </Grid>
          </Grid>

          <Grid item>
            {action === 'geoloc' ? (
              <IconButton
                data-testid="geoloc"
                onClick={() => {
                  dispatch(
                    getLocations({
                      filterWith: param,
                      research: '',
                      latitude: CASABLANCA.lat,
                      longitude: CASABLANCA.lon,
                    }),
                  );
                  pushTo(PAGES.SERVICES);
                }}
              >
                <ChevronRightOutlined />
              </IconButton>
            ) : (
              <StyledCallIcon
                container
                justify="center"
                alignItems="center"
                type={type}
              >
                <Grid item>
                  <PhoneInTalkOutlinedIcon />
                </Grid>
                <Grid item>
                  <StyledLink href={`tel:${param}`}>
                    <StyledItemActionText type={type}>
                      {phoneText}
                    </StyledItemActionText>
                  </StyledLink>
                </Grid>
              </StyledCallIcon>
            )}
          </Grid>
        </Grid>
      </StyledItemWrapper>
    </GaClickHOC>
  );
};

export default Item;
